<template>
  <div class="block-card" v-if="currClient">
    <van-cell title="我的企业" :label="currClient.client_name" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['currClient'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/commons/my-company.vue